import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useQueryClient } from '@tanstack/react-query';
import { RecipeForm } from '../components/recipe/RecipeForm';
import { ErrorBoundary } from '../components/ui/ErrorBoundary';
import { db } from '../lib/db';

export default function NewRecipePage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (data: any) => {
    setIsSubmitting(true);

    try {
      console.log('Submitting recipe:', data);

      // Create the recipe
      const id = crypto.randomUUID();
      const newRecipe = {
        id,
        ...data,
        createdAt: new Date(),
        updatedAt: new Date(),
      };

      // Add to database
      await db.recipes.add(newRecipe);

      // Update UI
      await queryClient.invalidateQueries({ queryKey: ['recipes'] });
      toast.success('Recipe created successfully!');
      navigate(`/recipes/${id}`);
    } catch (error) {
      console.error('Failed to create recipe:', error);
      toast.error('Failed to create recipe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ErrorBoundary
      fallback={
        <div className="text-center py-12">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Something went wrong</h2>
          <p className="text-gray-600 mb-4">There was an error creating the recipe.</p>
          <button
            onClick={() => window.location.reload()}
            className="text-indigo-600 hover:text-indigo-500"
          >
            Try again
          </button>
        </div>
      }
    >
      <div className="max-w-3xl mx-auto p-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Create New Recipe</h1>
        <RecipeForm
          onSubmit={handleSubmit}
          isLoading={isSubmitting}
          disabled={isSubmitting}
        />
      </div>
    </ErrorBoundary>
  );
}